<template>
    <div style="padding: 0 10px;box-sizing: border-box;">
        <el-row :gutter="20" style="margin-top: 10px;margin-right:0;">
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <el-table :data="tabList" size="mini" highlight-current-row @current-change="handleUnitChange"
                    :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border>
                        <el-table-column prop="unitCode" label="单据编码" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="unitName" label="单位名称" show-overflow-tooltip> </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="20">
               <el-button size="mini" style="margin-bottom: 10px;" @click="addSign" type="info">新增续费</el-button>
               <div class="bg-purple" style="border-radius: 4px;min-height: 100px;">
                    <el-descriptions title="基本信息" :column="4">
                        <el-descriptions-item label="单位全称">{{unitObj.name}}</el-descriptions-item>
                        <el-descriptions-item label="纳税识别号">{{unitObj.nsrsbh}}</el-descriptions-item>
                        <el-descriptions-item label="联系人">{{unitObj.manage}}</el-descriptions-item>
                        <el-descriptions-item label="联系电话">{{unitObj.managePhone}}</el-descriptions-item>
                        <el-descriptions-item label="AppKey">{{unitObj.appKey}}</el-descriptions-item>
                        <el-descriptions-item label="AppSecret">{{unitObj.appSecret}}</el-descriptions-item>
                    </el-descriptions>
               </div>
               <div class="bg-purple" style="border-radius: 4px;min-height: 300px;margin-top: 10px;">
                    <el-descriptions title="订阅状态"></el-descriptions>
                    <el-table :data="subscriptionList" size="mini" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border>
                        <el-table-column prop="name" label="服务类型" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="lastDate" label="最近订阅期间" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="useCount" label="使用数量" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="totalCount" label="累计数量" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="status" label="服务状态" show-overflow-tooltip> </el-table-column>
                    </el-table>
               </div>
               <div class="bg-purple" style="border-radius: 4px;min-height: 255px;margin-top: 10px;" >
                    <el-descriptions title="签约记录"></el-descriptions>
                    <el-table height="200px" :data="signList" size="mini" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border>
                        <el-table-column prop="signDate" label="签约日期" width="150"> </el-table-column>
                        <el-table-column prop="amount" label="金额" width="100"> </el-table-column>
                        <el-table-column prop="name2" label="服务期间" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{  scope.row.startTime }} 至 {{  scope.row.endTime }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="manager" label="客户经理" width="120" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="document" label="对应文件" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-tag type="primary" style="cursor: pointer;" @click="downloadFile(scope.row)" disable-transitions>{{scope.row.document}}</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
               </div>
            </el-col>
        </el-row>

        <!-- 新增签约 -->
        <service-sign-dialog :unitInfo="unitObj"  :dialogVisible="signDialogVisible" @close="closeSign"></service-sign-dialog>

    </div>
</template>
<script>
import { getBaseInfoByCode , listUnit } from "@/api/unit";
import { subscriptionListByUnitCode , signListByUnitCode  } from "@/api/service";
import ServiceSignDialog from './dialog/ServiceSignDialog.vue';
import { Message,MessageBox } from 'element-ui';

export default {
  components: { ServiceSignDialog },
    data(){
        return{
            form:{},
            unitObj : {
                name: '',
                code: '',
                manage : '',
                managePhone: '',
                nsrsbh: ''
            },
            subscriptionList:[],
            signList: [],
            tabList:[],
            signDialogVisible: false
        }
    },
    created() {
        this.listUnitFunc();
    },
    methods: {
        //选择单位
        handleUnitChange(val) {
            let unitCode = val.unitCode;
            let this_ = this;
            this_.subscriptionList = [];
            getBaseInfoByCode(unitCode).then(res => {
                if(res.code == 200){
                    this_.unitObj = res.data;
                    this_.getSubscriptionListByUnitCode(res.data.code);
                    this_.getSignListByUnitCode(res.data.code);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //单位列表
        listUnitFunc(){
            let param = {
                pageNum: 1,
                pageSize: 2000
            }
            listUnit(param).then(res => {
                this.tabList = res.data.content;
            });
        },
        //订阅列表
        getSubscriptionListByUnitCode(unitCode){
            let this_ = this;
            subscriptionListByUnitCode(unitCode).then(res => {
                if(res.code == 200){
                   this_.subscriptionList = res.data;
                }
            }); 
        },
        //签约列表
        getSignListByUnitCode(unitCode){
            let this_ = this;
            signListByUnitCode(unitCode).then(res => {
                if(res.code == 200){
                   this_.signList = res.data;
                }
            }); 
        },

        //新增签约
        addSign(){
            let unit = this.unitObj;
            if(unit.code == null || unit.code == ''){
                this.$message.error('请先选择单位');
                return;
            }
            this.signDialogVisible = true;
        },
        //关闭弹窗
        closeSign(){
            if(this.unitObj.code != null && this.unitObj.code != ''){
               let unitCode = this.unitObj.code;
               this.getSubscriptionListByUnitCode(unitCode);
               this.getSignListByUnitCode(unitCode);
            }
            this.signDialogVisible = false;
        },

        //下载签约文件
        downloadFile(row){
            let id__ = row.fileId;
            if(id__ == null && id__ == ''){
                Message.error('文件不存在'); 
               return; 
            }
            window.location.href = 'api/baseService/download/' + id__;
        }

    }
}
</script>
<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 15px;
    padding-right: 8px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
   border: 1px solid #f3f3f3;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    border-radius: 4px;
    min-height: 770px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/renewConfig.vue